import React from "react";
import { StatusTagStyled } from "./styled";
import { Icons } from "components";

const PENDING = { status: ["pending"], label: "รอเริ่มภารกิจ", color: "#E5A603", bg: "#FFF7DC", width: "121px" };
const REGISTRATION = { status: ["registration"], label: "ช่วงลงทะเบียน", color: "#2473B8", bg: "#E1F1FF", width: "121px" };
const ACTIVE = { status: ["active"], label: "เริ่มภารกิจแล้ว", color: "#198754", bg: "#B8EFC2", width: "121px" };
const EXPIRED = { status: ["expired"], label: "สิ้นสุดภารกิจ", color: "#707070", bg: "#F0F0F0", width: "105px" };

const VARIANTS = {
  company_mission: [PENDING, REGISTRATION, ACTIVE, EXPIRED],
};

const DEFAULT_STYLE = { label: "-", color: "#707070", bg: "#F0F0F0", width: "auto" };

const StatusTag = ({ variant = "company_mission", status, showDot = true }) => {
  const statuses = VARIANTS[variant] || VARIANTS.company_mission;
  const style = statuses.find((item) => item.status.includes(status)) || DEFAULT_STYLE;

  return (
    <StatusTagStyled $color={style.color} $bg={style.bg} $width={style.width}>
      <div className="tag">
        {showDot && (
          <span className="dot">
            <Icons.Round color={style.color} />
          </span>
        )}
        <span className="label">{style.label}</span>
      </div>
    </StatusTagStyled>
  );
};

export default StatusTag;
